module.exports = __webpack_public_path__ + "img/ei-phone.b63f05db.svg";